// middleware/auth-guard.global.ts
export default defineNuxtRouteMiddleware(async (to) => {
  const { status, roles, ensureSession } = useAuth();

  const isAdminRoute = to.path.startsWith("/admin");

  // Public routes: no auth check
  if (!isAdminRoute) return;

  // Load session once per app lifecycle (unless you manually reset status to 'unknown')
  if (status.value === "unknown") {
    await ensureSession();
  }

  // Not logged in -> redirect
  if (status.value !== "authed") {
    return navigateTo("/login");
  }

  // Role checks
  if (isAdminRoute && !roles.value.includes("admin")) {
    return navigateTo("/"); // or /403
  }
});
